export default __webpack_public_path__ + "static/media/W_wdt_c_cap_2.1017d37a.mp3";